module.exports = __webpack_public_path__ + "static/media/BELT-VENUSBLP.e1a70bdd.png";